import { render, staticRenderFns } from "./SubscriptionReportBigNumbers.vue?vue&type=template&id=34c3b82c&scoped=true"
import script from "./SubscriptionReportBigNumbers.vue?vue&type=script&lang=js"
export * from "./SubscriptionReportBigNumbers.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionReportBigNumbers.vue?vue&type=style&index=0&id=34c3b82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3b82c",
  null
  
)

export default component.exports